/*
  Modish Furnishing - Intelligems price test display sync (Conversion Dude)

  Intelligems runs the price test through Shopify Cart Transform Functions, so
  cart + checkout already charge the test price. This file only makes the
  STOREFRONT DISPLAY match it, for visitors who are in a price test group.

  How it works
  - The theme tags price elements with data attributes (no IG selector setup
    needed, and formatting stays in GBP):
      [data-ig-price]         regular price           -> igData.price.getPriceByVariantId
      [data-ig-compare-price] strike-through price    -> igData.price.getComparePriceByVariantId
      [data-ig-installment]   instalment amount       -> test price / data-payment-count
    each with data-variant-id (and data-product-id).
  - Klarna on-site messaging placements get their data-purchase-amount updated.
  - If Intelligems returns null (no test, product not in the test, or visitor
    in control) nothing is touched, so control visitors see the theme as-is.
  - Re-runs on ig:ready, DOMContentLoaded and any DOM change (variant switch,
    collection filtering, quick view), so re-rendered prices are fixed too.
  - Exposes window.mfIgSync() and window.mfIgPriceCents(variantId, fallbackCents)
    for custom scripts (pdp-redo-quantity.js, style selector quick view).
  - Fires 'mf:ig-prices-synced' on document after each pass.

  Debug: window.__mfIgDebug = true
*/
(function () {
  'use strict';
  if (window.__mfIgSyncLoaded) return;
  window.__mfIgSyncLoaded = true;

  var VERSION = 'v2';

  function log() {
    if (window.__mfIgDebug) console.info.apply(console, ['[ig-sync]'].concat([].slice.call(arguments)));
  }

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  }

  function fmt(pounds) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(pounds);
    } catch (e) {
      return '£' + Number(pounds).toFixed(2);
    }
  }

  function api() {
    return window.igData && window.igData.price ? window.igData.price : null;
  }

  function num(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = Number(v);
    return isFinite(n) && n > 0 ? n : null;
  }

  function igPrice(variantId) {
    var a = api();
    if (!a || !variantId || typeof a.getPriceByVariantId !== 'function') return null;
    try { return num(a.getPriceByVariantId(String(variantId))); } catch (e) { return null; }
  }

  function igCompare(variantId) {
    var a = api();
    if (!a || !variantId || typeof a.getComparePriceByVariantId !== 'function') return null;
    try { return num(a.getComparePriceByVariantId(String(variantId))); } catch (e) { return null; }
  }

  window.mfIgPriceCents = function (variantId, fallbackCents) {
    var p = igPrice(variantId);
    return p === null ? fallbackCents : Math.round(p * 100);
  };

  window.mfIgCompareCents = function (variantId, fallbackCents) {
    var c = igCompare(variantId);
    return c === null ? fallbackCents : Math.round(c * 100);
  };

  function setText(el, text) {
    if (!el.hasAttribute('data-ig-orig')) el.setAttribute('data-ig-orig', el.textContent);
    if (el.textContent !== text) el.textContent = text;
  }

  function currentProductVariantId() {
    var input = document.querySelector(
      '.product-information form[action*="/cart/add"] input[name="id"], form[data-type="pdp-redo-add-to-cart-form"] input[name="id"], product-form-component form input[name="id"]'
    );
    if (input && input.value) return input.value;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.selectedVariantId) return meta.selectedVariantId;
    if (meta && meta.product && meta.product.variants && meta.product.variants[0]) return meta.product.variants[0].id;
    return null;
  }

  var klarnaTimer = null;
  function syncKlarna() {
    var placements = document.querySelectorAll('klarna-placement');
    if (!placements.length) return;
    var vid = currentProductVariantId();
    var p = igPrice(vid);
    if (p === null) return;
    var cents = String(Math.round(p * 100));
    var changed = false;
    for (var i = 0; i < placements.length; i++) {
      if (placements[i].getAttribute('data-purchase-amount') !== cents) {
        placements[i].setAttribute('data-purchase-amount', cents);
        changed = true;
      }
    }
    if (changed) {
      clearTimeout(klarnaTimer);
      klarnaTimer = setTimeout(function () {
        try {
          if (window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh) {
            window.Klarna.OnsiteMessaging.refresh();
          }
        } catch (e) { log('klarna refresh failed', e); }
      }, 50);
      log('klarna amount ->', cents);
    }
  }

  var syncing = false;
  function sync() {
    if (!api() || syncing) return;
    syncing = true;
    var count = 0;
    try {
      var els = document.querySelectorAll('[data-ig-price]');
      for (var i = 0; i < els.length; i++) {
        var p = igPrice(els[i].getAttribute('data-variant-id'));
        if (p !== null) { setText(els[i], fmt(p)); count++; }
      }

      var cmp = document.querySelectorAll('[data-ig-compare-price]');
      for (var j = 0; j < cmp.length; j++) {
        var c = igCompare(cmp[j].getAttribute('data-variant-id'));
        if (c !== null) { setText(cmp[j], fmt(c)); count++; }
      }

      var inst = document.querySelectorAll('[data-ig-installment]');
      for (var k = 0; k < inst.length; k++) {
        var ip = igPrice(inst[k].getAttribute('data-variant-id'));
        if (ip === null) continue;
        var n = parseInt(inst[k].getAttribute('data-payment-count'), 10) || 3;
        setText(inst[k], fmt(Math.round((ip * 100) / n) / 100));
        count++;
      }

      syncKlarna();
    } finally {
      syncing = false;
    }
    if (count) log('synced', count, 'elements');
    try { document.dispatchEvent(new CustomEvent('mf:ig-prices-synced', { detail: { count: count } })); } catch (e) {}
  }

  window.mfIgSync = sync;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // setTimeout, not requestAnimationFrame: rAF is paused in background tabs,
    // which left late-inserted prices (e.g. recently viewed) unsynced.
    setTimeout(function () {
      scheduled = false;
      sync();
    }, 30);
  }

  function observe() {
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      if (syncing) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('ig:ready', sync);
  if (Array.isArray(window.onIgReady)) window.onIgReady.push(sync);
  else if (typeof window.onIgReady === 'function') window.onIgReady = [window.onIgReady, sync];
  else window.onIgReady = [sync];

  function start() {
    sync();
    observe();
    // Late safety passes in case Intelligems resolves after first paint.
    setTimeout(sync, 800);
    setTimeout(sync, 2500);
  }

  console.info('[ig-sync] loaded ' + VERSION);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
